/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_seller = {
    readonly monthsSinceStartDate: number | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfoAndContact_seller" | "useSellerRating_seller">;
    readonly " $refType": "PdpRespSidebarSellerInfoAndContactLazy_seller";
};
export type PdpRespSidebarSellerInfoAndContactLazy_seller$data = PdpRespSidebarSellerInfoAndContactLazy_seller;
export type PdpRespSidebarSellerInfoAndContactLazy_seller$key = {
    readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_seller$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_seller",
  "selections": [
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContact_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSellerRating_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = 'cf3bffb1fca180a9ee2468bac80d4777';
export default node;
